// Mock data for Crescent Electrical Ltd website

export const companyInfo = {
  name: "Crescent Electrical Ltd",
  phone: "07711 233685",
  whatsapp: "447711233685",
  email: "info@electriccertificate.co.uk",
  serviceArea: "Greater London",
  googleRating: 5.0,
  reviewCount: 13,
  accreditation: "NICEIC Approved Contractor",
  businessHours: "Open until 9pm"
};

export const reviews = [
  {
    id: 1,
    name: "Mubeen Ahmed",
    role: "Local Guide • 158 reviews",
    rating: 5,
    date: "49 weeks ago",
    text: "Exceptional service when we had an issue with the electrics in our summer house. Highly professional and sorted the problem quickly."
  },
  {
    id: 2,
    name: "kerry clark",
    role: "",
    rating: 5,
    date: "29 Nov 2024",
    text: "Absolutely fantastic service. Came out the same day and fix my problem. Highly recommend!"
  },
  {
    id: 3,
    name: "Finsbury Furniture",
    role: "6 reviews",
    rating: 5,
    date: "7 Jun 2024",
    text: "We are very happy with the work they have done and will be using their services again. If you are looking for a competent team at competitive rates, you have come to the right place."
  },
  {
    id: 4,
    name: "Nicolas Nicolaou",
    role: "10 reviews",
    rating: 5,
    date: "6 Jun 2024",
    text: "Excellent service, and got the job done perfectly. Will highly recommend."
  },
  {
    id: 5,
    name: "Osman Mert",
    role: "3 reviews",
    rating: 5,
    date: "6 Jun 2024",
    text: "It's not easy to find a tradesman you can trust who actually cares about what they do and the impression that they leave. Highly professional and trustworthy."
  },
  {
    id: 6,
    name: "Rachel Carnell",
    role: "Local Guide • 13 reviews",
    rating: 5,
    date: "6 Jun 2024",
    text: "Excellent and professional!!"
  },
  {
    id: 7,
    name: "Cristina Gorcea",
    role: "1 review",
    rating: 5,
    date: "6 Jun 2024",
    text: "Quick service, very trustworthy👍"
  },
  {
    id: 8,
    name: "Charlie Marlie",
    role: "12 reviews",
    rating: 5,
    date: "6 Jun 2024",
    text: "Highly reccomend, they did a fantastic job in re-wiring my house. Very polite honest and professional service."
  },
  {
    id: 9,
    name: "Hasan ozkoc (Hass)",
    role: "Local Guide • 129 reviews",
    rating: 5,
    date: "6 Jun 2024",
    text: "Every house hold needs this! Cresent electricals did this for me and amongst many other electrical work in the house. Outstanding service and quality workmanship."
  },
  {
    id: 10,
    name: "Ender Cemgil",
    role: "13 reviews",
    rating: 5,
    date: "7 Jun 2024",
    text: "Professional electrical service. Very satisfied with the quality of work."
  },
  {
    id: 11,
    name: "ALEXA MUESES",
    role: "7 reviews",
    rating: 5,
    date: "7 Jun 2024",
    text: "Great service, professional team. Would definitely recommend."
  },
  {
    id: 12,
    name: "Anuradha Rajan",
    role: "1 review",
    rating: 5,
    date: "6 Jun 2024",
    text: "Excellent electrical work. Very professional and efficient."
  },
  {
    id: 13,
    name: "N O",
    role: "4 reviews",
    rating: 5,
    date: "26 May 2022",
    text: "Cem was very professional and gave us amazing ideas of what we could do with our new house. We especially love our stair and kitchen lighting which he installed. Top quality service."
  }
];

export const services = [
  {
    id: 1,
    title: "EICR – Landlord Safety Certificates",
    icon: "FileCheck",
    shortDesc: "Comprehensive electrical safety inspections for landlords and letting agents",
    fullDesc: "An Electrical Installation Condition Report (EICR) is a legal requirement for all rental properties in England. Our qualified electricians conduct thorough inspections to ensure your property meets current safety standards.",
    includes: [
      "Full property electrical inspection",
      "Detailed safety report",
      "Certification for landlord compliance",
      "Identification of any defects or issues",
      "Recommendations for remedial work"
    ],
    whoFor: "Landlords, letting agents, property managers, HMO owners",
    turnaround: "24-48 hours"
  },
  {
    id: 2,
    title: "Consumer Unit / Fuse Board Upgrades",
    icon: "Zap",
    shortDesc: "Modern, safe consumer units with RCD protection",
    fullDesc: "Old fuse boards can be dangerous and don't meet current regulations. We upgrade to modern 18th Edition consumer units with circuit breakers and RCD protection for enhanced safety.",
    includes: [
      "Remove old fuse board",
      "Install new 18th Edition consumer unit",
      "RCD protection fitted",
      "Full testing and certification",
      "Clean, professional installation"
    ],
    whoFor: "Homeowners, landlords, commercial properties",
    turnaround: "Same day installation"
  },
  {
    id: 3,
    title: "Full & Partial Rewires",
    icon: "Cable",
    shortDesc: "Complete rewiring solutions for properties of all sizes",
    fullDesc: "Whether you need a complete rewire or partial update, our experienced team delivers high-quality work with minimal disruption to your property.",
    includes: [
      "Full property assessment",
      "New cables and accessories",
      "Modern sockets and switches",
      "Updated to current regulations",
      "Full certification provided"
    ],
    whoFor: "Homeowners, landlords, renovation projects",
    turnaround: "Scheduled to suit"
  },
  {
    id: 4,
    title: "Emergency Lighting Certification",
    icon: "Lightbulb",
    shortDesc: "Testing and certification for HMOs and commercial properties",
    fullDesc: "Emergency lighting is essential for HMOs and commercial buildings. We test, maintain, and certify your emergency lighting systems to meet legal requirements.",
    includes: [
      "Emergency lighting inspection",
      "Function and duration testing",
      "Battery checks",
      "Certification issued",
      "Recommendations for upgrades"
    ],
    whoFor: "HMO landlords, commercial property owners",
    turnaround: "Fast turnaround"
  },
  {
    id: 5,
    title: "Fault Finding & Repairs",
    icon: "Wrench",
    shortDesc: "Expert diagnosis and repair of electrical faults",
    fullDesc: "Electrical problems can be frustrating and dangerous. Our experienced electricians quickly identify and fix faults to get your property safe and functional.",
    includes: [
      "Diagnostic testing",
      "Fault identification",
      "Professional repair work",
      "Safety testing",
      "Advice on prevention"
    ],
    whoFor: "All property types",
    turnaround: "Emergency callouts available"
  }
];

export const whyChooseUs = [
  {
    icon: "Clock",
    title: "Priority Callouts",
    description: "Fast response times and emergency services available"
  },
  {
    icon: "BadgePoundSterling",
    title: "Competitive Rates",
    description: "Fair pricing with no hidden costs. Bulk discounts available"
  },
  {
    icon: "ShieldCheck",
    title: "Fully Certified Work",
    description: "NICEIC approved with all work certified to current standards"
  },
  {
    icon: "Users",
    title: "Experienced & Professional",
    description: "Trusted by landlords, letting agents and property managers across London"
  }
];

export const trustBadges = [
  {
    title: "NICEIC Approved",
    subtitle: "Contractor"
  },
  {
    title: "5.0 Rating",
    subtitle: "Google Reviews"
  },
  {
    title: "Fully Insured",
    subtitle: "Public Liability"
  },
  {
    title: "Fast Turnaround",
    subtitle: "24-48 Hours"
  }
];
